import { Stack, Typography } from '@mui/material';
import IncPageBody from 'components/inc-page/inc-page-body/inc-page-body.component';
import IncPage from 'components/inc-page/inc-page.component';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <IncPage>
      <IncPageBody
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <Stack alignItems="center">
          <Typography fontSize={64} fontWeight={100}>
            404
          </Typography>
          <Typography variant="h1">{t('page.notFound.title')}</Typography>
        </Stack>
      </IncPageBody>
    </IncPage>
  );
};
export default NotFound;
